import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

const currentModelTypeState = atom<'standart' | 'premium'>({
    key: 'currentModelTypeState',
    default: 'standart',
});

export const useCurrentModelTypeValue = () => useRecoilValue(currentModelTypeState);

export const useSetCurrentModelTypeValue = () => useSetRecoilState(currentModelTypeState);
